import { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useCart } from 'lib/core/hooks'
import { getPaymentMethod } from 'lib/core/data/quote/paymentMethod/selectors'
import { placeOrder as _placeOrder } from 'lib/core/data/quote/placeOrder'

export type PlaceOrderMethod = (params?: PlaceOrderParams) => void

type UsePaymentMethod = (params: {
  placeOrder: PlaceOrderMethod
  code: string
}) => void

interface PlaceOrderParams {
  poNumber?: string
  additionalData?: Record<string, any>
}

export const usePaymentMethod = (onInit: UsePaymentMethod) => {
  const dispatch = useDispatch()
  const { cartId, cart } = useCart()
  const { code, initialized } = useSelector(getPaymentMethod(cartId))
  const onInitRef = useRef<UsePaymentMethod | undefined>()
  onInitRef.current = onInit

  useEffect(() => {
    if (!cartId || !code || !initialized) {
      return
    }

    const placeOrder: PlaceOrderMethod = (params) => {
      dispatch(_placeOrder(cartId, cart?.data, {
        method: code,
        additional_data: params?.additionalData,
        po_number: params?.poNumber
      }))
    }

    // FIX: HDSG-694 - Had to remove cart?.data from the dependency array to prevent duplicate orders.

    onInitRef.current?.({ placeOrder, code })
    // eslint-disable-next-line
  }, [
    initialized,
    cartId,
    code,
    dispatch
  ])

  return {}
}
